import React from 'react';
import './FaceSvg.css';
//thanks https://icons.getbootstrap.com/icons/mic/
const FaceSvg = props => {
    return (
        <svg className="FaceSvg" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#fffffff0" viewBox="76.6559 118.4924 28.371499999999997 29.50399999999999">
            <path d="m 105.02744,147.99642 -7.460319,-3.7579 -0.0564,-2.05744 0.150635,-1.7205 c 0,0 1.046692,-2.39183 1.046692,-3.8862 0,0 1.046337,0.8957 1.419932,-1.12148 0.3736,-2.01718 0.89676,-5.7531 -0.747184,-4.85669 0,0 0.33655,-2.98838 0.03775,-4.78155 -0.299161,-1.79317 -1.830567,-7.32226 -8.70409,-7.32226 -6.873875,0 -8.405283,5.52909 -8.704439,7.32226 -0.298802,1.79317 0.03775,4.78155 0.03775,4.78155 -1.643945,-0.89641 -1.120775,2.83951 -0.747184,4.85669 0.373592,2.01718 1.419931,1.12148 1.419931,1.12148 0,1.49437 1.046691,3.8862 1.046691,3.8862 l 0.150636,1.7205 0.0073,2.153 -7.269193,3.66234" />
        </svg>
    )
};


export default FaceSvg;